import {
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_BEGIN,
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_SUCCESS,
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_FAILURE,
    SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitSystemConfig(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_BEGIN,
      });
  
      let apiurl = '/api/b/systemConfig/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/systemConfig/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitSystemConfigError() {
    return {
      type: SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitSystemConfigPending: true,
          submitSystemConfigError: null,
        };
  
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_SUCCESS:
        // The request is success
        return {
          ...state,
          submitSystemConfigPending: false,
          submitSystemConfigError: null,
        };
  
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_FAILURE:
        // The request is failed
        return {
          ...state,
          submitSystemConfigPending: false,
          submitSystemConfigError: action.data.error,
        };
  
      case SYSTEMCONFIG_SUBMIT_SYSTEMCONFIG_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitSystemConfigError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/submitSystemConfig.js